'use client';
import { randomId } from '@s7/utils';

function createAriaHider(containerNode, selector = 'body > :not(script)') {
    const id = randomId();
    const rootNodes = Array.from(document.querySelectorAll(selector)).map((node)=>{
        var _node_shadowRoot;
        if ((node == null ? void 0 : (_node_shadowRoot = node.shadowRoot) == null ? void 0 : _node_shadowRoot.contains(containerNode)) || node.contains(containerNode)) {
            return undefined;
        }
        const ariaHidden = node.getAttribute('aria-hidden');
        const prevAriaHidden = node.getAttribute('data-hidden');
        const prevFocusId = node.getAttribute('data-focus-id');
        node.setAttribute('data-focus-id', id);
        if (ariaHidden === null || ariaHidden === 'false') {
            node.setAttribute('aria-hidden', 'true');
        } else if (!prevAriaHidden && !prevFocusId) {
            node.setAttribute('data-hidden', ariaHidden);
        }
        return {
            node,
            ariaHidden: prevAriaHidden || null
        };
    });
    return ()=>{
        rootNodes.forEach((item)=>{
            /*
             * Если узел содержит целевой контейнер или id focus trap изменился, не выполняем очистку
             * */ if (!item || id !== item.node.getAttribute('data-focus-id')) {
                return;
            }
            if (item.ariaHidden === null) {
                item.node.removeAttribute('aria-hidden');
            } else {
                item.node.setAttribute('aria-hidden', item.ariaHidden);
            }
            item.node.removeAttribute('data-focus-id');
            item.node.removeAttribute('data-hidden');
        });
    };
}

export { createAriaHider };
//# sourceMappingURL=createAriaHider.js.map
